<div class="quote-column container-fluid">
  <div class="row quote-common-row g-0">
    <div class="col">
      <app-order-common-row-view [data]="data"></app-order-common-row-view>
    </div>
  </div>
  <div class="row quote-details-row g-0" [ngClass]="{
    'quote-details-row--highlighted': isHighlighted
  }">
    <div class="col">
      <app-order-details-row-view [data]="data"></app-order-details-row-view>
    </div>
  </div>
</div>